import * as types from "../constants/ActionTypes";
var initialState = false;

var showLoadingPage = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_SHOW_LOADING_PAGE:
      state = action.showLoadingPage;
      return state;
    default:
      return state;
  }
};
export default showLoadingPage;
